import { render, staticRenderFns } from "./amis.vue?vue&type=template&id=654400b2&scoped=true&"
import script from "./amis.vue?vue&type=script&lang=js&"
export * from "./amis.vue?vue&type=script&lang=js&"
import style0 from "./amis.vue?vue&type=style&index=0&id=654400b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654400b2",
  null
  
)

export default component.exports